<template><div class="dropdown-divider"></div></template>
<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({ name: 'BDropdownDivider' })
</script>
